import * as React from 'react'
import { Text, View } from 'react-native'
import { CircleButton } from '../components/CircleButton'
import styles from './styles'

export function SetANeedGoalButton() {
  return (
    <View style={styles.innerCard}>
      <Text style={styles.label}>Set a Need Goal</Text>
      <CircleButton
        flavor="default"
        icon={{ prefix: 'fal', iconName: 'plus' }}
      />
    </View>
  )
}
